module.exports = __webpack_public_path__ + "assets/img/6_490_big.a433df03.jpg";